import { IconsProps } from '@/types/shared'
import React from 'react'

const DriveIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 22 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M17.5 8C17.67 8 17.83 8.01 17.99 8.02L13.5 0H7.5L13.18 9.84C14.27 8.71 15.8 8 17.5 8Z"
                    fill="currentColor"
                />
                <path
                    d="M6.65 1.52L0.5 12.5L3.5 18L9.83 7.03L6.65 1.52Z"
                    fill="currentColor"
                />
                <path
                    d="M11.7 12.5H8.4L5.23 18H13.04C12.08 16.94 11.5 15.54 11.5 14C11.5 13.48 11.57 12.98 11.7 12.5Z"
                    fill="currentColor"
                />
                <path
                    d="M18.5 13V10H16.5V13H13.5V15H16.5V18H18.5V15H21.5V13H18.5Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default DriveIcons
